import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Heading,
  Stack,
} from '@chakra-ui/react';
import WorkTypeResource from 'api/work_type';
import { CenterSpinner } from 'components/common/CenterSpinner';
import { strings } from 'config/localization';
import routes from 'constants/routes';
import React from 'react';
import { useQuery } from 'react-query';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { truncateString } from 'utils';
import history from 'utils/history';
import WorkTypeStepList from './WorkTypeStepList';

const ViewWorkType: React.FC = () => {
  const { id }: any = useParams();
  const workTypeApi = new WorkTypeResource();

  const workTypeQuery = useQuery<any>(
    [`work-type${id}`, id],
    () => workTypeApi.get(id).then((res) => res?.data),
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  );

  if (workTypeQuery.isLoading) {
    return <CenterSpinner />;
  }

  if (workTypeQuery.isError) {
    history.push(routes.companies.list);
  }

  const labelStyles = {
    color: 'gray.900',
    fontWeight: 'bold',
  };
  const infoStyles = {
    color: 'gray.600',
    fontWeight: 'normal',
  };

  return (
    <>
      <Stack direction="column" spacing="4">
        <Breadcrumb color="gray.400" size="4">
          <BreadcrumbItem>
            <BreadcrumbLink as={RouterLink} to={routes.workType.list}>
              {strings.work_type}
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage color="gray.900">
            <BreadcrumbLink textTransform="capitalize">
              {truncateString(workTypeQuery?.data?.name || '')}
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <Flex justify="space-between">
          <Heading size="md" textTransform="capitalize">
            {strings.work_type_details}
          </Heading>
          <Stack direction="row" spacing="6">
            <Button
              size="sm"
              colorScheme="primary"
              onClick={() =>
                history.push(routes.workType.edit.replace(':id', id))
              }>
              {strings.edit_work_type}
            </Button>
          </Stack>
        </Flex>

        <Stack bg="white" p={['3', '6']} shadow="box" rounded="sm">
          <Grid
            gap="4"
            templateColumns={['repeat(2, 1fr)', 'repeat(4, 1fr)']}
            w="100%">
            <GridItem>
              <FormControl>
                <FormLabel sx={labelStyles}>{strings.name}</FormLabel>
                <Box sx={infoStyles}>{workTypeQuery?.data?.name || '-'}</Box>
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel sx={labelStyles}>{strings.description}</FormLabel>
                <Box sx={infoStyles}>
                  {workTypeQuery?.data?.description || '-'}
                </Box>
              </FormControl>
            </GridItem>
          </Grid>
        </Stack>

        <WorkTypeStepList id={workTypeQuery?.data?.id} company_detail={workTypeQuery?.data.company_details} />
      </Stack>
    </>
  );
};

export default ViewWorkType;
